import type { ExperimentConfig } from '../@types'

// DEV-34687. "Combat Readiness Score" (Strength / Endurance / Recovery breakdown +
// rank-style "Below Standard" / "Combat Ready" framing) replaces the plan-progress
// graph at the end of the Activity block on the male military-calisthenics funnel.
//
// B = "Combat Readiness Score" in the familiar design, C = the aggressive design.
//
// NOTE on the variant→element mapping (`getAppAreaExperiment`, src/funnels/funnels.ts:213):
// `variantIndex = variant > 0 ? variant - 1 : 0`, so variant 0 (control) AND variant 1 (B) both
// resolve to element [0]. The control group therefore loads
// `ob-male-military-calisthenics-combat-score` as well — the split between A and B happens
// inside that funnel, via `conditionsForShow` on `featureKey` (`==` / `!=` screen pairs).
// Variant 2 (C) is the only one reaching element [1]. `…-combat-score-c` is a clone of B and keeps
// the same conditions; `resolveFeatureFlag` is `Boolean(treatment())`, so under variant 2 the `==`
// screens (dark-skin score) show and the `!=` ones (control eligibility) stay hidden. That
// condition is also what registers the exposure — the funnel part of `getAppAreaExperiment`
// deliberately never calls `treatment()` itself.
const config: ExperimentConfig[] = [
	{
		'activity-male-military-calisthenics': {
			// /military-calisthenics-m?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_military_calisthenics_combat_readiness_score~1
			funnel: {
				id: 'ob-male-military-calisthenics-combat-score',
				locale: ['en'],
			},
		},
		'activity-female-military-calisthenics': {
			// /military-calisthenics-f?safe&mock-data&utm_source=FB&country=US&area=activity-female-military-calisthenics&exp=web_military_calisthenics_combat_readiness_score~1
			funnel: {
				id: 'ob-female-military-calisthenics-combat-score-b',
				locale: ['en'],
			},
		},
	},
	{
		'activity-male-military-calisthenics': {
			// /military-calisthenics-m?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_military_calisthenics_combat_readiness_score~2
			funnel: {
				id: 'ob-male-military-calisthenics-combat-score-c',
				locale: ['en'],
			},
		},
		'activity-female-military-calisthenics': {
			// /military-calisthenics-f?safe&mock-data&utm_source=FB&country=US&area=activity-female-military-calisthenics&exp=web_military_calisthenics_combat_readiness_score~2
			funnel: {
				id: 'ob-female-military-calisthenics-combat-score-c',
				locale: ['en'],
			},
		},
	},
]

export default config
